import { compareStrings, nullSafeGetOrElse } from './DataAccessUtils';
import { ROLE_TYPES } from './DataConstants';
import { isAllowedToPerform, isSupplierAllowedToAccess, PERMISSION_NAMES } from './AuthUtils';
import { infinityButNumber } from '../constants/general';

export const isInApprovalHierarchy = (currentUser, approvalHierarchy) => {
	const tiers = nullSafeGetOrElse('tierDetails', approvalHierarchy, []);
	const approvers = tiers.flatMap((tier) => tier.approvers);
	return approvers.some((approver) => approver.email === currentUser.email);
};

export const isUserAllowedToFullyApprove = (user, approvalHierarchy, companyConfig, amount = 0) => {
	if (approvalHierarchy) {
		const tiers = nullSafeGetOrElse('tierDetails', approvalHierarchy, []);
		const userTier = tiers.find((tier) =>
			tier.approvers.some((approver) => compareStrings(approver.email, user.email))
		);
		if (parseFloat(nullSafeGetOrElse('amountUpto', userTier, infinityButNumber)) >= amount) {
			return true;
		}
	} else {
		return user.userType === ROLE_TYPES.SUPPLIER
			? isSupplierAllowedToAccess(PERMISSION_NAMES.CAN_APPROVE_INVOICES, companyConfig, user.roles)
			: isAllowedToPerform(PERMISSION_NAMES.CAN_APPROVE_INVOICES, companyConfig, user.roles);
	}
	return false;
};

export const getFirstUnapprovedTierWithApprovers = (tiers) => {
	for (const tier of tiers) {
		const approvers = nullSafeGetOrElse('approvers', tier, []);
		const approvedByUsers = nullSafeGetOrElse('approvedByUsers', tier, []);
		if (approvers.length === 0) {
			continue;
		}
		if (approvedByUsers.length === 0) {
			return tier;
		}
	}
	return undefined;
};

export const checkSequentialApprovalBlock = (tiers, myTier) => {
	const nextTier = getFirstUnapprovedTierWithApprovers(tiers);
	if (!nextTier) {
		return { blocked: false };
	}
	if (
		!compareStrings(
			nullSafeGetOrElse('label', nextTier, ''),
			nullSafeGetOrElse('label', myTier, '')
		)
	) {
		return {
			blocked: true,
			reason: `Sequential approval is enforced. Tier ${nullSafeGetOrElse(
				'label',
				nextTier,
				'1'
			)} must approve first.`,
		};
	}
	return { blocked: false };
};

export const defaultTier = {
	name: '',
	approvers: [],
	showSearch: false,
	label: 1,
	id: 1,
};

export const approvalRuleTypes = {
	QUOTE: 'quote',
	INVOICE: 'invoice',
	PURCHASE_REQUEST: 'purchaseRequest',
	WORK_ORDER: 'workOrder',
};
